import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppState } from '../../../reducers';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { selectAuthUserReports } from '../../auth/auth.selectors';
import { SaveReportsConfigAction } from '../profile.actions';

import { Checkbox, CHECKBOX_INFO, ReportsCheckboxes } from '../../reports/reports.models';
import { Actions } from 'atlas-cdk';
import { ToastService } from '../../../shared/toaster_/toaster_.service';

@Component({
  standalone: false,
  selector: 'dsp-profile-reports',
  templateUrl: 'reports.component.html',
  styleUrls: ['reports.component.scss']
})
export class ProfileReportsComponent implements OnInit, OnDestroy {
  public reports: ReportsCheckboxes;
  public allCheckbox: boolean;

  public reports$: Observable<Checkbox[]>;
  public reportsList = {
    financialMarketsUpdate: false,
    performanceCommentary: false,
    portfolio: false,
    extendedReturns: false,
    totalReturns: false,
    excessBefore: false,
    excessAfter: false
  } as ReportsCheckboxes;

  private readonly subscription: Subscription = new Subscription();

  public constructor(
    private readonly store: Store<AppState>,
    private readonly _toasterService: ToastService
  ) {
    this.reports$ = this.selectReports();
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeReports());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onSubmit(): void {
    this.store.dispatch(new SaveReportsConfigAction({ allCheckbox: this.allCheckbox, checkboxes: this.reports }));
  }

  public onCancel(): void {
    this.store.pipe(
      select(selectAuthUserReports),
      take(1)
    ).subscribe(reports => {
      this.allCheckbox = Object.entries(this.reportsList)
        .every(([key, value]) => !!reports[key]);
      this.reports = { ...reports } as ReportsCheckboxes;
      //this.store.dispatch(new AddErrorToastAction('Changes have been cancelled'));
      return this._toasterService.launchAlertError('Changes have been cancelled', Actions.error);
    });
  }

  public onSelectAny(): void {
    const reports = { ...this.reports };
    this.allCheckbox = Object.entries(this.reportsList)
      .every(([key, value]) => !!reports[key]);
  }

  public onSelectAllToggle(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.allCheckbox = input.checked;
    this.onSelectAll();
  }

  public onSelectReportToggle(event: Event, reportKey: string): void {
    const input = event.target as HTMLInputElement;
    this.reports[reportKey] = input.checked;
    this.onSelectAny();
  }

  public onSelectAll(): void {
    const allCheckbox = this.allCheckbox;
    Object.keys(this.reportsList).forEach(key => this.reports[key] = allCheckbox);
  }

  private selectReports(): Observable<Checkbox[]> {
    return this.store.pipe(
      select(selectAuthUserReports),
      map(reports =>
        Object.keys(this.reportsList || {}).map(key =>
        ({ key, ...CHECKBOX_INFO[key], checked: (reports[key] != null ? reports[key] : false) }
        ))
      )
    );
  }

  private subscribeReports(): Subscription {
    return this.store.pipe(
      select(selectAuthUserReports)
    ).subscribe(reports => {
      this.allCheckbox = Object.entries(this.reportsList)
        .every(([key, value]) => !!reports[key]);
      this.reports = { ...reports } as ReportsCheckboxes;
    });
  }
}
